const initialState = { notifications: [] };

export default initialState;